import React from 'react';
import Icon from '../../../components/Icon';
import { formatDate } from './utils';

export default function RegistrationProgress({ steps, completedStepCount, registrationMessage, lastUpdatedAt }) {
    const allStepsComplete = steps.length > 0 && completedStepCount === steps.length;

    return (
        <div className="db-card">
            <div className="db-card-header">
                <span className="db-card-title">System Registration Progress</span>
                {allStepsComplete ? (
                    <span className="db-badge db-badge--active">
                        <Icon type="check" size={12} color="#22C55E" />
                        Active
                    </span>
                ) : (
                    <span className="db-badge db-badge--pending">
                        {completedStepCount} / {steps.length} complete
                    </span>
                )}
            </div>
            <div className="db-milestone-body">
                <div className="db-milestone-track">
                    {steps.map((step, i) => (
                        <div key={i} className="db-milestone-step">
                            {i < steps.length - 1 && (
                                <div className={`db-milestone-line${steps[i + 1].completed ? ' db-milestone-line--done' : ''}`} />
                            )}
                            <div className={`db-milestone-dot${step.completed ? ' db-milestone-dot--done' : ''}`}>
                                {step.completed ? "✓" : i + 1}
                            </div>
                            <div className="db-milestone-label">{(step.labels || []).join(' ')}</div>
                        </div>
                    ))}
                </div>
                {registrationMessage && (
                    <p className="db-milestone-message">{registrationMessage}</p>
                )}
                {lastUpdatedAt && (
                    <p className="db-milestone-updated">Last updated: {formatDate(lastUpdatedAt)}</p>
                )}
            </div>
        </div>
    );
}
